module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer full"
  }, [_c('section', {
    staticClass: "flexContainer fd-c full t-fd-r t-fw-nw",
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('AdminTools'), _vm._v(" "), _c('section', {
    staticClass: "planosWrapper flexContainer jc-sb mobileNot"
  }, [_c('section', {
    staticClass: "searchResultsWrapper size3of4 flexContainer fd-c tabletNot"
  }, [_c('section', [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [_c('div', {
    staticClass: "flexContainer ai-c jc-sb btnExp pointer",
    on: {
      "click": function($event) {
        _vm.createComponent();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("componentType.create")))])]), _vm._v(" "), _c('hr', {
    staticClass: "full mt10 separator"
  }), _vm._v(" "), _c('transition-group', {
    staticClass: "resultsWrapper flexContainer fw-w",
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.componentTypeList), function(n) {
    return (n.active !== false) ? _c('div', {
      key: n.name,
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs"
    }, [_c('div', {
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs list"
    }, [_c('div', {
      staticClass: "listDisplay full ai-c jc-sb flexContainer"
    }, [_c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [_c('span', {
      staticClass: "listTitle uppercase center"
    }, [_vm._v(_vm._s(n.name))])]), _vm._v(" "), _c('div', {
      staticClass: "fd-c size1of5"
    }, [_c('span', {
      staticClass: "roundedIcon pointer",
      on: {
        "click": function($event) {
          _vm.editComponent(n.id);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-pencil-alt"
    })]), _vm._v(" "), _c('span', {
      staticClass: "roundedIcon pointer",
      on: {
        "click": function($event) {
          _vm.deleteComponentType(n.id);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash-alt"
    })])])])])]) : _vm._e()
  }))], 1)])]), _vm._v(" "), (_vm.newComponent) ? _c('CreateComponentType', {
    on: {
      "hideCreateComponent": function($event) {
        _vm.modalClose($event);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editComp) ? _c('EditComponentType', {
    on: {
      "hideEditComponent": function($event) {
        _vm.modalClose2($event);
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab2094ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/componentType/ComponentList.vue
// module id = 3340
// module chunks = 0